import { faLocationDotSlash } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Typography from "@mui/material/Typography";
import { PublicPortalTheme } from "@publicPortal/theme/MuiPublicPortal.module";
import React from "react";
import "./NoGeometryMessage.css";

const NoGeometryMessage = () => {
    return (
        <div className="noGeometryMessage">
            <FontAwesomeIcon icon={faLocationDotSlash} style={PublicPortalTheme.icons.sizeL} className="noGeometryMessage__icon--primary" />
            <Typography variant="h5" component="div">
                Application record doesn't have geometry
            </Typography>
        </div>
    );
};

export default NoGeometryMessage;
